



import { Children, createContext, useContext, useState } from "react";
export const StatesContext = createContext();
const MyStateProvider = ({ children }) => {
    // Templates Create
    const [selectedWabaId, setSelectedWabaId] = useState("");
    const [selectedPhoneNumberId, setSelectedPhoneNumberId] = useState("");

    const provider = {
        selectedWabaId,
        setSelectedWabaId,
        selectedPhoneNumberId,
        setSelectedPhoneNumberId,
    };

    return (
        <StatesContext.Provider value={provider}>
            {children}
        </StatesContext.Provider>
    );
};

const useStateContex = () => useContext(StatesContext);

export { MyStateProvider, useStateContex };
